import { combineReducers } from 'redux';
import { ACTION } from './constants';

let initialState = { isLoading: false };

export default function DistributorCornerReducer(state = initialState, action) {
    switch (action.type) {

        case ACTION.GET_DISTRIBUTOR_CORRNER:
            return { ...state, distributorCorner: action.data};
        case ACTION.GET_DISTRIBUTOR_CORRNER_FAQ:
            return { ...state, distributorCornerFaq: action.data};
        case ACTION.GET_DISTRIBUTOR_CORRNER_ONBOARD_DIGITALLY:
            return { ...state, distributorCornerOnboardDigitally: action.data};
        case ACTION.GET_DISTRIBUTOR_CORRNER_ONBOARD_LOGIN:
            return { ...state, distributorCornerOnboardLogin: action.data};
        case ACTION.DISTRIBUTOR_CORRNER_WHYBE:
            return { ...state, distributorCornerWhyBe: action.data};
        case ACTION.DISTRIBUTOR_CORRNER_GETSTARTED:
            return { ...state, distributorGetStarted: action.data};
        case ACTION.DISTRIBUTOR_BECOME_DISTRIBUTOR:
            return { ...state, distributorBecomeData: action.data};
        case ACTION.DISTRIBUTOR_CORRNER_FORM_DISCLOSURE:
            return { ...state, distributorFormDisclosureData: action.data };
        case ACTION.DISTRIBUTOR_CORRNER_SEBI:
            return { ...state, distributorSebiData: action.data };
        case ACTION.GET_HANDBOOK:
            return { ...state, handBookData: action.data };
        case ACTION.GET_HANDBOOK_DETAILS:
            return { ...state, handBookDetailData: action.data };
            
        default:
            return state;
    }
}
